export type Locale = 'en' | 'sq'

export type Localized<T> = Record<Locale, T>

export const defaultLocale: Locale = 'en'

export const siteLocales: Array<Locale> = ['en', 'sq']

export const localeNames: Localized<{ short: string, name: string, hreflang: string }> = {
    en: { short: 'EN', name: 'English', hreflang: 'en' },
    sq: { short: 'SQ', name: 'Shqip', hreflang: 'sq' }
}

export const toLocale = (value?: string | null): Locale => value === 'sq' ? 'sq' : 'en'

export const intlLocale = (locale: Locale): string => locale === 'sq' ? 'sq' : 'en-GB'

export const localePath = (locale: Locale, path: string): string => {
    const clean = path.startsWith('/') ? path : `/${path}`
    if (locale === defaultLocale) return clean
    return clean === '/' ? `/${locale}` : `/${locale}${clean}`
}

export const pick = <T,>(value: Localized<T>, locale: Locale): T => value[locale] ?? value[defaultLocale]
